export default "__VITE_ASSET__D_dAPbzu__"